'use strict'

import VacancyApi from './../../api/vacancy.js'

const state = {
  data: [],
  loading: false,
  error: null
}

const getters = {
  getCategories (state) {
    return state.data ? state.data : []
  }
}

const actions = {
  fetch ({commit}) {
    commit('request')

    VacancyApi.categoriesFetch()
    .then(data => commit('success', data))
    .catch(error => commit('failure', error))
  }
}

const mutations = {
  request (state) {
    state.loading = true
    state.data = null
    state.error = null
  },

  failure (state, error) {
    state.loading = false
    state.error = error
  },

  success (state, data) {
    state.loading = false
    state.data = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
